import { z } from "zod";

const zIn = z.object({
  to: z.array(z.string().email()),
  subject: z.string().nonempty(),
  body: z.string().nonempty(),
});
type In = z.infer<typeof zIn>;

export { zIn };
export type { In };
